import React, { useState, useCallback, useEffect } from 'react'

export interface IImage extends React.ImgHTMLAttributes<HTMLImageElement> {
    /** the image to display */
    src: string;
    /**(optional) displays if the src image is not found */
    errorImg?: string;
    /**(optional) displays while the src image loads */
    placeHolderImg?: string;
    /**(optional) description of image */
    imgAlt?: string;
}

/**
 * image with built-in loader placeholder. ss specific, not candidate for ui-kit
 * @param src
 * @param errorImg
 * @param placeHolderImg
 * @param imgAlt
 * @param props
 * @constructor
 * @deprecated
 */
const ImageComponent = ({
    src,
    errorImg = "https://static.secur.space/app-images/not-found-image/place_holder_image.png",
    placeHolderImg = "/image-loader.gif",
    imgAlt = '',
    ...props
}: IImage) => {
    const [imgSrc, setSrc] = useState(placeHolderImg);
    const onLoad = useCallback(() => {
        setSrc(src);
    }, [src]);

    const onError = useCallback(() => {
        setSrc(errorImg);
    }, [errorImg]);


    useEffect(() => {
        const img = new Image();
        img.src = src;
        img.addEventListener("load", onLoad);
        img.addEventListener("error", onError);
    }, [src, onLoad, onError]);
    return <img alt={imgAlt} src={imgSrc} {...props}  />;
}

export default ImageComponent